import SepaBatchConfirmationRequest from 'src/adminPanel/entities/offsetting/sepaBatch/SepaBatchConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_SEPA_BATCHES = 'FETCH_SEPA_BATCHES';
export const REQUEST_SEPA_BATCHES = 'REQUEST_SEPA_BATCHES';
export const SUCCESS_SEPA_BATCHES = 'SUCCESS_SEPA_BATCHES';
export const FAILURE_SEPA_BATCHES = 'FAIL_SEPA_BATCHES';

export const fetchSepaBatches = (
    pageable?: PageableQueryParams,
    batchNumber?: string | undefined,
    confirmedState?: boolean | undefined
) => action(FETCH_SEPA_BATCHES, { pageable, batchNumber, confirmedState });
export const requestSepaBatches = () => action(REQUEST_SEPA_BATCHES);
export const requestSepaBatchesSuccess = (response: any) => action(SUCCESS_SEPA_BATCHES, { response });
export const requestSepaBatchesFailure = (error: any) => action(FAILURE_SEPA_BATCHES, { error });

export const FETCH_SEPA_BATCH_PREVIEW = 'FETCH_SEPA_BATCH_PREVIEW';
export const REQUEST_SEPA_BATCH_PREVIEW = 'REQUEST_SEPA_BATCH_PREVIEW';
export const SUCCESS_SEPA_BATCH_PREVIEW = 'SUCCESS_SEPA_BATCH_PREVIEW';
export const FAILURE_SEPA_BATCH_PREVIEW = 'FAILURE_SEPA_BATCH_PREVIEW';

export const fetchSepaBatchPreview = (id: string) => action(FETCH_SEPA_BATCH_PREVIEW, { id });
export const requestSepaBatchPreview = () => action(REQUEST_SEPA_BATCH_PREVIEW);
export const requestSepaBatchPreviewSuccess = (response: any) => action(SUCCESS_SEPA_BATCH_PREVIEW, { response });
export const requestSepaBatchPreviewFailure = (error: any) => action(FAILURE_SEPA_BATCH_PREVIEW, { error });

export const CONFIRM_SEPA_BATCH = 'CONFIRM_SEPA_BATCH';
export const REQUEST_CONFIRM_SEPA_BATCH = 'REQUEST_CONFIRM_SEPA_BATCH';
export const SUCCESS_CONFIRM_SEPA_BATCH = 'SUCCESS_CONFIRM_SEPA_BATCH';
export const FAILURE_CONFIRM_SEPA_BATCH = 'FAILURE_CONFIRM_SEPA_BATCH';

export const confirmSepaBatch = (id: string, sepaBatchConfirmationRequest: SepaBatchConfirmationRequest) =>
    action(CONFIRM_SEPA_BATCH, { id, sepaBatchConfirmationRequest });
export const requestConfirmSepaBatch = () => action(REQUEST_CONFIRM_SEPA_BATCH);
export const requestConfirmSepaBatchSuccess = (response: any) => action(SUCCESS_CONFIRM_SEPA_BATCH, { response });
export const requestConfirmSepaBatchFailure = (error: any) => action(FAILURE_CONFIRM_SEPA_BATCH, { error });
